
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { en } from 'vuetify/src/locale';

Vue.use(VueI18n);
if (!localStorage.getItem('lang')) {
  localStorage.setItem('lang', 'en');
}
// const defaultLocale = 'en';

// const getStartingLocale = () => {
//   const browserLocale = navigator?.language?.split('-')[0];
//   const lastLocale = localStorage.getItem('last-locale');

//   return lastLocale && Object.keys(messages).includes(lastLocale)
//     ? lastLocale
//     : browserLocale && Object.keys(messages).includes(browserLocale)
//       ? browserLocale
//       : defaultLocale;
// };
const messages = {

  en: {
    $vuetify: {
      ...en,
    },
    labels: {
      firstName: 'First Name',
    },
  },
  te: {
    $vuetify: {
      ...en,
    },
    labels: {
      firstName: '1First Name',
    },
  },

};

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
